// src/components/layout/Layout.tsx
import { useState, useEffect, useMemo } from "react";
import {
  faClipboardList,
  faBriefcase,
  faUsers,
  faImage,
  faFileAlt,
  faAddressCard,
  faBars,
  faPercent,
  faCheck,
  faHandshake,
  faBuilding,
  faMoneyCheck,
  faNewspaper,
  faPhone,
  faEnvelope,
  faPeopleCarry,
  faMoneyBill,
  faGlobe,
  faChartLine,
} from "@fortawesome/free-solid-svg-icons";
import "../../css/Sidebar.css";
import logo from "../../image/logo_alo.png";
import NouvelleAnnonce from "../../page/client/NouvelleAnnonce";
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import GestionEmail from "../../page/admin/Gestion_Email";
import GestionAnnonce from "../../page/client/GestionAnnonce";
import Header from "./header";
import Footer from "./footer";
import ListUser from "../../page/admin/ListUser";
import GestionLogo from "../../page/client/Gestion_Logos";
import GestionDeMonCompte from "../../page/client/gestion_de_mon_compte/GestionDeMonCompte";
import NavBar from "./NavBar";
import parame from "../../image/blanc5.png";
import contactImg from "../../image/operateur-service-client-parlant-au-telephone-dans-bureau_1301-7538.jpg";
import GestionFactureUser from "../GestionDeMesFactures";
import ListesAnnonces from "../../page/admin/ListesAnnoncesAdmin";
import ManagedPostalCodes from "../../page/admin/ManagedPostalCodes";
import ListeTypesAnnonce from "../../page/admin/ListeTypesAnnonce";
import GestionParrainage from "../../page/client/parainage/GestionParrainage";
import Annuaire from "../../page/client/Annuaire";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import { fetchUserDetails } from "../../userThunk";
import InfoKBIS from "../../page/shared/InfoKBIS";
import DraftTable from "../../page/client/draft/DraftTable";
import MyBalance from "../../page/MyBalance";
import AdminSoldePage from "../Gestionsolde";
import { useBadge } from "../../context/BadgeContext";
import useAppContext from "../../hooks/useAppContext";
import { AppContextType } from "../../context/AppContext";
import { getAllAnnonceByUser } from "../../services/Annonce_service";
import { Annonce } from "../../models/AnnonceModel";
import PromoManagementLayout from "../../page/admin/promo-management/PromoManagementLayout";
import DemandeTable from "../../page/admin/GestionDemande";
import { FaPhone, FaEnvelope, FaLink, FaPhoneAlt } from "react-icons/fa";
import ContactModal from "../../page/client/ContactModal";
import { FaHeadset, FaClock, FaArrowRight } from "react-icons/fa";
import { motion } from "framer-motion";
import { Card } from "antd";
import GestionCompteAdmin from "../admin/GestionCompteAdmin";
import TarifsLegalin from "../../page/admin/scraping/TarifsLegalin";
import ProfessionSettings from "../../page/admin/ProfessionSettings";
import MenuClicksDashboard from "../MenuClickDashboard";
import EmailTemplatesManager from "../emailTemplate/EmailTemplatesManager";
import { trackMenuClick } from "../../services/menuClick_service";

interface UserModel {
  user_type: "personne" | "entreprise";
  is_entreprise: boolean;
  unpaid_annonce_limit?: number;
  unpaid_amount_limit?: number;
}

const Layout = () => {
  const [activeItem, setActiveItem] = useState("");
  const [roleUser, setRoleUser] = useState("");
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
  const [isTabletScreen, setIsTabletScreen] = useState(
    window.innerWidth > 768 && window.innerWidth <= 1024
  );

  const navigate = useNavigate();
  const location = useLocation();
  const authUser: UserModel | null = useSelector((state: RootState) => state.user.user!) as UserModel;
  const dispatch: AppDispatch = useDispatch();

  const { logos, demandes, resetBadge } = useBadge();
  const { setActiveIndex, setUserAnnonces } = useAppContext() as AppContextType;
  const [hiddenBadges, setHiddenBadges] = useState<string[]>([]);

  const [showContactModal, setShowContactModal] = useState(false);
  const handleOpenModal = () => setShowContactModal(true);
  const handleCloseModal = () => setShowContactModal(false);


  const handleContactMessageClick = () => {
  trackMenuClick('aide-contact-message', 'Envoyer un message - Support');
  handleOpenModal();
};
  const [unpaidCount, setUnpaidCount] = useState<number>(0);
  const [unpaidAmount, setUnpaidAmount] = useState<number>(0);
  const [canCreate, setCanCreate] = useState<boolean>(true);

  useEffect(() => {
    if (!authUser) {
      dispatch(fetchUserDetails());
    }
  }, [dispatch, authUser]);

  const fetchAnnonces = async () => {
    let isMounted = true;
    try {
      const fetchedAnnonces = await getAllAnnonceByUser();
      if (!isMounted) return;
      if (fetchedAnnonces) {
        setUserAnnonces(fetchedAnnonces.filter((annonce: Annonce) => annonce.status !== 3));

        const unpaidAnnonces = fetchedAnnonces.filter((item: any) => !item.isPaid);
        const unpaidTotal = unpaidAnnonces.reduce((sum: number, item: any) => {
          const amount = parseFloat(item.montantTTC) || 0;
          return sum + amount;
        }, 0);

        setUnpaidCount(unpaidAnnonces.length);
        setUnpaidAmount(unpaidTotal);

        setCanCreate(unpaidTotal <= 1000);
      } else {
        setUnpaidCount(0);
        setUnpaidAmount(0);
        setCanCreate(true);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des annonces:", error);
      setUnpaidCount(0);
      setUnpaidAmount(0);
      setCanCreate(true);
    }
    return () => {
      isMounted = false;
    };
  };

  useEffect(() => {
    fetchAnnonces();
  }, [authUser]);

  const getIsEntreprise = () => {
    if (authUser?.user_type === "entreprise" || authUser?.is_entreprise) {
      return true;
    }

    const isEntrepriseString = localStorage.getItem("isEntreprise");
    const localIsEntreprise = isEntrepriseString ? JSON.parse(isEntrepriseString) : false;

    if (localIsEntreprise && authUser && authUser.user_type === "personne") {
      localStorage.setItem("isEntreprise", "false");
      return false;
    }

    return localIsEntreprise;
  };

  // console.log("authUser:",authUser)

  const isEntreprise = getIsEntreprise();

  useEffect(() => {
    if (authUser) {
      const shouldBeEntreprise = authUser.user_type === "entreprise" || authUser.is_entreprise;
      const currentLocalStorageValue = localStorage.getItem("isEntreprise");
      const currentIsEntreprise = currentLocalStorageValue ? JSON.parse(currentLocalStorageValue) : false;

      if (shouldBeEntreprise !== currentIsEntreprise) {
        localStorage.setItem("isEntreprise", JSON.stringify(shouldBeEntreprise));
      }
    }
  }, [authUser?.user_type, authUser?.is_entreprise]);

  const userStatus = localStorage.getItem("userStatus") || "anonymous";

  const is_validated = JSON.parse(localStorage.getItem("isvalidated") || "false");
  const userType = localStorage.getItem("userType")

  const itemMenuAdmin = useMemo(
    () => [
      {
        path: "/home/admin/users",
        key: "listUser",
        value: "Liste des utilisateurs",
        icon: faUsers,
      },
      {
        path: "/home/admin/annonces",
        key: "listAnnonce",
        value: "Liste des annonces",
        icon: faClipboardList,
      },
      {
        path: "/home/admin/parrainage",
        key: "gestionParrainage",
        value: "Parrainage",
        icon: faHandshake,
      },
      {
        path:"/home/admin/email-template",
        key:"email-template",
        value:"Gestion des templates",
        icon: faEnvelope
      },
      {
        path: "/home/admin/emails",
        key: "gestionEmail",
        value: "Mails",
        icon: faEnvelope,
      },
      {
        path: "/home/admin/factures",
        key: "GestionFactures",
        value: "Gestion de mes factures",
        icon: faFileAlt,
      },
      {
        path: "/home/admin/demande-validation",
        key: "Demande",
        value: "Demande de validation",
        icon: faCheck,
      },
      {
        path: "/home/admin/codes-postals",
        key: "managedPostalcodes",
        value: "Gestion des codes postaux",
        icon: faAddressCard,
      },
      {
        path: "/home/gestion-logos",
        key: "GestionLogos",
        value: `Gestion des logos`,
        icon: faImage,
      },
      {
        path: "/home/info-kbis",
        key: "info-kbis",
        value: "Extrait des sociétés",
        icon: faBuilding,
      },
      {
        path: "/home/admin/gestion-codes-promo",
        key: "gestionCodesPromo",
        value: "Gestion des promotions",
        icon: faPercent,
      },
      {
        path: "/home/admin/prix-type-annonce",
        key: "PrixTypeAnnonce",
        value: "Prix type d'annonce",
        icon: faMoneyCheck,
      },
      {
        path: "/home/admin/solde",
        key: "soldeclient",
        value: "Gestion de soldes et avoirs",
        icon: faMoneyBill
      },
      {
        path:"/home/admin/parametres",
        key:"gestionannuaire",
        value:"Gestion de l'annuaire",
        icon:faBuilding
      },
      {
        path:"/home/admin/dashboard",
        key:"dashboard",
        value:"Suivi des clics",
        icon:faChartLine
      }
      
    ],
    []
  );

  const itemMenuClient = useMemo(
    () => {
      const menu = [
        {
          path: "/home/nouvelle-annonce",
          key: "NouvelleAnnonce",
          value: "Nouvelle annonce",
          icon: faNewspaper,
        },
        ...(userStatus !== "anonymous"
          ? [
            {
              path: "/home/gestion-annonces",
              key: "GestionAnnonces",
              value: "Mes annonces",
              icon: faClipboardList,
            },
          ]
          : []),
        {
          path: "/home/draft",
          key: "Draft",
          value: "Mes brouillons",
          icon: faBars,
        },
        ...(userStatus !== "anonymous"
          ? [
            {
              path: "/home/gestion-compte",
              key: "GestionCompte",
              value: "Mon compte",
              icon: faBriefcase,
            },
          ]
          : []),
        {
          path: "/home/gestion-factures",
          key: "GestionFactures",
          value: "Mes factures",
          icon: faFileAlt,
        },
        ...((userType !== "personne")
          ? [{
            path: "/home/mon-solde",
            key: "MonSolde",
            value: "Mes soldes",
            icon: faMoneyCheck,
          }] :
          []),
          ...(isEntreprise
          ? [
            {
              path: "/home/annuaire",
              key: "Annuaire",
              value: "Annuaire",
              icon: faUsers, 
            },
          ]
          : []),
        ...( (userStatus !== "anonymous")
          ? [
            {
              path: "/home/gestion-logos",
              key: "GestionLogos",
              value: `Mes  logos`,
              icon: faImage,
            },
          ]
          : []),

        {
          path: "/home/info-kbis",
          key: "info-kbis",
          value: "Extrait des sociétés",
          icon: faBuilding,
        },
        {
          path: "/home/gestion-emails",
          key: "gestionEmail",
          value: "Mes emails",
          icon: faEnvelope,
        },
        {
          path: "/home/gestion-clients",
          key: "GestionClients",
          value: "Parrainages",
          icon: faHandshake,
        },

        ...((isSmallScreen || isTabletScreen) && roleUser === "CLIENT"
          ? [
            {
              path: "#",
              key: "AideSupport",
              value: "Aide et support",
              icon: faPhone,
            },
          ]
          : []),
      ];
      return menu;
    },
    [authUser, isSmallScreen, isTabletScreen, roleUser]
  );

  const menuItems = useMemo(() => {
    if (roleUser === "ADMIN") {
      return itemMenuAdmin;
    } else if (roleUser === "CLIENT") {
      return itemMenuClient;
    }
    return [];
  }, [roleUser, itemMenuAdmin, itemMenuClient]);

  useEffect(() => {
    if (!localStorage.getItem("userId")) {
      navigate("/");
      return;
    }
    const storedRole = localStorage.getItem("role") || "";
    setRoleUser(storedRole);

    const currentPath = location.pathname;
    const currentItem =
      (storedRole === "ADMIN" ? itemMenuAdmin : itemMenuClient).find((item) =>
        currentPath.includes(item.path)
      );

    if (currentItem) {
      setActiveItem(currentItem.key);
    } else {
      setActiveItem(storedRole === "ADMIN" ? "listUser" : "NouvelleAnnonce");
    }
  }, [navigate, location.pathname, itemMenuAdmin, itemMenuClient]);
  const renderContent = () => {

    const annonceLimitReached =
      authUser &&
      unpaidCount >= (authUser.unpaid_annonce_limit || 0) &&
      unpaidAmount >= (authUser.unpaid_amount_limit || 0);

    switch (activeItem) {
      case "NouvelleAnnonce":
        return !annonceLimitReached ? (
          <NouvelleAnnonce />
        ) : (
          <div
            style={{
              padding: "24px",
              borderRadius: 8,
              background: "#fff8f0",
              border: "1px solid #f5c6a5",
              textAlign: "center",
              margin: "20px",
            }}
          >
            <h2 style={{ color: "#d46a00" }}>Création bloquée</h2>
            <p>
              Vous avez <strong>{unpaidCount}</strong> annonce(s) impayée(s) pour un montant total de{" "}
              <strong>{unpaidAmount.toFixed(2)} €</strong>.
            </p>
            <p>Le plafond de création est atteint :</p>
            <ul style={{ listStyle: "none", padding: 0 }}>
              <li>Nombre max d'annonces impayées : {authUser.unpaid_annonce_limit}</li>
              <li>Montant max impayé : {authUser.unpaid_amount_limit} €</li>
            </ul>
            <p>Veuillez régulariser vos paiements pour débloquer la création.</p>
            <div style={{ display: "flex", justifyContent: "center", marginTop: "12px" }}>
              <button
                onClick={() => {
                  setActiveItem("GestionAnnonces");
                  navigate("/home/gestion-annonces");
                }}
                style={{
                  padding: "8px 14px",
                  borderRadius: 6,
                  border: "none",
                  cursor: "pointer",
                  background: "#2A919D",
                  color: "white",
                }}
              >
                Gestion des annonces
              </button>
            </div>
          </div>
        );
      case "GestionAnnonces":
        return <GestionAnnonce />;
      case "GestionCompte":
        return <GestionDeMonCompte />;
      case "GestionClients":
      case "gestionParrainage":
        return <GestionParrainage />;
      case "GestionLogos":
        return <GestionLogo />;
      case "gestionEmail":
        return <GestionEmail />;
      case "GestionFactures":
        return <GestionFactureUser />;
      case "Demande":
        return <DemandeTable />;
      case "typesAnnonces":
        return <ListeTypesAnnonce />;
      case "listUser":
        return <ListUser />;
      case "listAnnonce":
        return <ListesAnnonces />;
      case "managedPostalcodes":
        return <ManagedPostalCodes />;
      case "Draft":
        return <DraftTable />;
      case "info-kbis":
        return <InfoKBIS />;
      case "MonSolde":
        return <MyBalance />;
      case "soldeclient":
        return <AdminSoldePage/>
      case "gestionCodesPromo":
        return <PromoManagementLayout />;
      case "PrixTypeAnnonce":
        return <ListeTypesAnnonce />;
      case "soldeclient":
        return <AdminSoldePage />;
      case "TarifsLegalin":
        return <TarifsLegalin />;
      case "Annuaire":
        return <Annuaire />;
      case "gestionannuaire":
        return <ProfessionSettings />;
      case "dashboard":
        return <MenuClicksDashboard />;
      case "email-template":
        return <EmailTemplatesManager/>
      default:
        return null;
    }
  };

  const handleParameClick = () => {
    navigate("/region");
  };

const handleMenuActive = (item: { key: string; path: string; value: string }) => {
  if (item.key === "AideSupport") {
    handleOpenModal();
    return;
  }

  trackMenuClick(item.key, item.value); 

  console.log(" Menu active:", item.key);
  if (typeof setActiveIndex === "function") setActiveIndex(0);
  setHiddenBadges((prev) => [...prev, item.key]);
  setActiveItem(item.key);
  navigate(item.path);
};

  const renderMenuItems = (
  handleMenuActive: (item: { key: string; path: string; value: string }) => void
  ) => {
    return menuItems.map((item) => {
      let badgeCount: number | null = null;

      if (roleUser === "ADMIN") {
        if (item.key === "GestionLogos" && logos > 0) {
          badgeCount = logos;
        } else if (item.key === "Demande" && demandes > 0) {
          badgeCount = demandes;
        }
      }

      // Badge: affiche le NOMBRE d'annonces impayées
      if (item.key === "GestionAnnonces" && unpaidCount > 0) {
        badgeCount = unpaidCount;
      }

      const isActive = activeItem === item.key;

      return (
        <div
          key={item.key}
          className={`sidebar-item ${isActive ? "active" : ""} position-relative d-flex align-items-center ${item.key === "AideSupport" ? "mobile-only" : ""}`}
          style={!isActive ? { background: "#EAF2F3" } : {}}
          onClick={() => {
            handleMenuActive(item);
          }}
        >
          <FontAwesomeIcon icon={item.icon} className="menu-icon" />
          <span className="menu-label">{item.value}</span>
          {badgeCount && badgeCount > 0 && !hiddenBadges.includes(item.key) && (
            <span
              className="menu-badge badge rounded-pill bg-danger"
              aria-label={`${badgeCount} éléments non payés`}
            >
              {badgeCount > 99 ? "99+" : badgeCount}
            </span>
          )}

        </div>
      );
    });
  };

  return (
    <>
      <div className="layout">
        <div className="left-dash">
          <div className="logo-dash-left ">
            <a href="/">
              <img src={logo} width="80%" height="80%" alt="logo" />
            </a>
          </div>
          <div className="menu-dash">{renderMenuItems(handleMenuActive)}</div>
          {roleUser === "CLIENT" && (
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              style={{
                margin: "16px 0",
                padding: "0 8px",
              }}
            >
              <Card
                hoverable
                style={{
                  background: "#EAF2F3",
                  border: "1px solid #e6f7ff",
                  borderRadius: "12px",
                  boxShadow: "0 4px 12px rgba(42, 145, 157, 0.08)",
                  overflow: "hidden",
                  position: "relative",
                  transition: "all 0.3s ease",
                }}
                bodyStyle={{ padding: "20px 16px" }}
              >
                {/* Titre avec icône */}
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "16px"
                }}>
                  <div style={{
                    background: "linear-gradient(135deg, #4BB0C0 0%, #2A919D 100%)",
                    width: "36px",
                    height: "36px",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "10px",
                    boxShadow: "0 2px 8px rgba(75, 176, 192, 0.3)"
                  }}>
                    <FaHeadset style={{ color: "white", fontSize: "18px" }} />
                  </div>
                  <h3 style={{
                    color: "#2A919D",
                    fontSize: "18px",
                    fontWeight: "700",
                    fontFamily: "'Mulish', sans-serif",
                    margin: 0,
                    background: "linear-gradient(135deg, #2A919D 0%, #4BB0C0 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text"
                  }}>
                    AIDE & CONTACT
                  </h3>
                </div>

                {/* Image */}
                <motion.div
                  whileHover={{ scale: 1.02 }}
                  style={{
                    marginBottom: "20px",
                    textAlign: "center",
                    position: "relative",
                    overflow: "hidden",
                    borderRadius: "10px"
                  }}
                >
                  <img
                    src={contactImg}
                    alt="Service client"
                    style={{
                      width: "100%",
                      maxWidth: "280px",
                      height: "140px",
                      objectFit: "cover",
                      borderRadius: "10px",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                      border: "2px solid #e6f7ff"
                    }}
                  />
                  {/* Overlay décoratif */}
                  <div style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: "linear-gradient(to bottom, transparent 70%, rgba(42, 145, 157, 0.1))",
                    borderRadius: "10px"
                  }} />
                </motion.div>

                {/* Boutons de contact */}
                <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                  {/* Bouton Email */}
                  <motion.button
                    whileHover={{ scale: 1.02, x: 5 }}
                    whileTap={{ scale: 0.98 }}
                    onClick={handleContactMessageClick}                    
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      gap: "12px",
                      padding: "10px 12px",
                      background: "#fff",
                      border: "1px solid #4bb0c0",
                      borderRadius: "8px",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      width: "100%",
                      textAlign: "left"
                    }}
                  >
                    <div style={{
                      background: "#4BB0C0",
                      width: "36px",
                      height: "36px",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0
                    }}>
                      <FaEnvelope style={{ color: "white", fontSize: "10px" }} />
                    </div>
                    <div>
                      <div style={{
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#4bb0c0",
                        marginBottom: "2px"
                      }}>
                        Envoyer un message
                      </div>
                    </div>
                  </motion.button>

                  {/* Bouton Téléphone */}
                  <motion.div
                    whileHover={{ scale: 1.02, x: 5 }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      gap: "12px",
                      padding: "14px 16px",
                      background: "#fff",
                      border: "1px solid #4bb0c0",
                      borderRadius: "8px",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      width: "100%"
                    }}
                  >
                    <div style={{
                      background: "#4bb0c0",
                      width: "36px",
                      height: "36px",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0
                    }}>
                      <FaPhoneAlt style={{ color: "white", fontSize: "10px" }} />
                    </div>
                    <div>
                      <div style={{
                        fontSize: "16px",
                        fontWeight: "700",
                        color: "#4bb0c0",
                        fontFamily: "'Segoe UI', monospace"
                      }}>
                        01 88 84 48 44
                      </div>
                    </div>
                  </motion.div>
                </div>

                {/* Effet décoratif */}
                <div style={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  width: "60px",
                  height: "60px",
                  background: "linear-gradient(135deg, rgba(75, 176, 192, 0.1) 0%, transparent 100%)",
                  borderBottomLeftRadius: "100%",
                  zIndex: 0
                }} />
              </Card>
            </motion.div>
          )}

          <div className="parame">
            {roleUser === "CLIENT" && (
              <img src={parame} alt="" onClick={handleParameClick} style={{ cursor: "pointer", marginTop: "5px" }} />
            )}
          </div>
        </div>
        <div className="right-dash">
          <NavBar menuContent={renderMenuItems(handleMenuActive)} />
          <Header />
          <div className="contenu-dashboard">{renderContent()}</div>
          <Footer />
        </div>
      </div>

      <ContactModal show={showContactModal} onClose={handleCloseModal} />
    </>
  );
};

export default Layout;